import { useRive } from '@rive-app/react-canvas';
import nosell from 'assets/rive/nosell.riv';
import noresult from 'assets/rive/noresult.riv';
import { Box, Typography } from '@mui/material';
import noproductsfound from 'assets/rive/noproductsfound.riv';

type Props = {
  variant?: 'noresult' | 'nosell';
  text?: string;
};

function RiveResult({ variant = 'noresult', text = 'нет данных' }:Props) {
  const src: any = {
    noproductsfound: noproductsfound,
    noresult: noresult,
    nosell: nosell,
  };

  const riveParams = {
    src: src[variant],
    artboard: 'New Artboard',
    autoplay: true,
  };

  const { RiveComponent } = useRive(riveParams);

  return (
    <Box className='animation-canvas'>
      <Box style={{ width: '100%', height: 200 }}>
        <RiveComponent />
      </Box>
      <Typography textAlign='center' variant='subtitle1' className='text'>
        {text}
      </Typography>
    </Box>
  );
}

export default RiveResult;
